"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/core/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Tag.scss");
const Tag = _ref => {
  let {
    label,
    iconName,
    onClick,
    onDismiss,
    isDismissible = false
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Tag', {
    'cds-Tag--Clickable': onClick || isDismissible
  });
  const handleClick = () => {
    onClick?.();
    if (isDismissible) {
      onDismiss?.();
    }
  };
  return /*#__PURE__*/_react.default.createElement("li", {
    className: rootClassName,
    onClick: handleClick
  }, iconName && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: iconName
  }), label);
};
exports.Tag = Tag;
//# sourceMappingURL=Tag.js.map